import { Tracking as OrdersTracking } from '@modules/Orders/ViewOrders/components/display/Tracking';
import { FC } from 'react';
import type { OrderShipment } from '@modules/Orders/ViewOrders/models/Order';

interface TrackingProps {
  shipment?: OrderShipment;
}

export const Tracking: FC<TrackingProps> = (props) => {
  return <OrdersTracking {...props} />;
};
